import { render, staticRenderFns } from "./chgPwd.vue?vue&type=template&id=f4435c74&scoped=true"
import script from "./chgPwd.vue?vue&type=script&lang=js"
export * from "./chgPwd.vue?vue&type=script&lang=js"
import style0 from "./chgPwd.vue?vue&type=style&index=0&id=f4435c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4435c74",
  null
  
)

export default component.exports